export default __webpack_public_path__ + "static/media/founderimage02.0ee1894c.png";